(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.ListeningQuerySearchRecommendations = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, DataSourceFilterGroupIds) {
        return {

            storageDimensions: [
                'recommendationId'
            ],

            availableDimensions: [
            ],

            fields: {
                recommendationId: {
                },
                description: {
                    dataType: dataType.STRING
                },
                query: {
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.listening
            ]
        };
    }
})();
